import {
  SHOP_BREADCRUMB_REQUEST,
  SHOP_BREADCRUMB_SUCCESS,
  // SHOP_BREADCRUMB_FAILURE,
  SHOP_BREADCRUMB_CLEAR,
} from 'app/common/actions/shop/catalog/breadcrumb';


const defaultState = {
  data: {},
  loading: false, // ! здесь нельзя ставить true, потому как компоненту breadcrumb не всегда требуется загрузка данных, но при этом с loading: true он всегда отображается в процессе загрузки
};

const breadcrumb = (state = defaultState, { type, payload }) => {
  switch (type) {
    case SHOP_BREADCRUMB_REQUEST: {
      return { ...state, loading: true };
    }

    case SHOP_BREADCRUMB_SUCCESS: {
      return {
        ...state,
        loading: false,
        data: { ...state.data, ...payload },
      };
    }

    case SHOP_BREADCRUMB_CLEAR: {
      return defaultState;
    }

    default:
  }
  return state;
};

export default breadcrumb;
